<template>
  <div>
    <component
        :is="pageView"
        v-bind="$attrs"
        @switchPage="toggleComponent"
    />
  </div>
</template>

<script setup>
import home from './home.vue'
import statistUseQuery from './statistUseQuery'
import fullInvoiceQuery from './fullInvoiceQuery.vue'


const pageView = shallowRef(home);

function toggleComponent(ev) {
  switch (ev.key) {
    case 'home':
      pageView.value = home
      break
    case 'statistUseQuery':
      pageView.value = statistUseQuery;
      break
    case 'fullInvoiceQuery':
      pageView.value = fullInvoiceQuery;
      break
  }
}
</script>


<style scoped lang="scss">

</style>
